import { datadogRum } from '@datadog/browser-rum';
import { User as DatadogUser } from '@datadog/browser-core';
import { NonOptional } from '@insight-health-ai/roseate/utils';

let isInitialized = false;

type User = NonOptional<DatadogUser, 'id' | 'name' | 'email'>;

export const RUM = {
  init: () => {
    if (isInitialized) return;
    if (
      import.meta.env.VITE_DD_ENABLE == 'true' &&
      !window.location.hostname.includes('localhost')
    ) {
      isInitialized = true;
      datadogRum.init({
        applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        site: import.meta.env.VITE_DD_SITE,
        service: import.meta.env.VITE_DD_SERVICE,
        env: import.meta.env.VITE_DD_ENVIRONMENT,
        sessionSampleRate: parseInt(import.meta.env.VITE_DD_SAMPLE_RATE),
        sessionReplaySampleRate: parseInt(
          import.meta.env.VITE_DD_SESSION_SAMPLE_RATE
        ),
        version: import.meta.env.VITE_COMMIT_HASH,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
      });
    }
  },
  setUser: (user: User) => {
    if (isInitialized) {
      datadogRum.setUser(user);
    }
  },
  clearUser: () => {
    if (isInitialized) {
      datadogRum.clearUser();
    }
  },
};
